import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "../context/AuthContext";
import ProfileTab from "../components/settings/ProfileTab";
import CompanyTab from "../components/settings/CompanyTab";
import UsersTab from "../components/settings/UsersTab";
import SecurityLogsTab from "../components/settings/SecurityLogsTab";
import DangerZone from "../components/settings/DangerZone";
import RoleManagement from "../components/settings/RoleManagement";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PaymentSection } from "../components/settings/company/PaymentSection";
import { PaymentHistorySection } from "../components/settings/subscription/PaymentHistorySection";
import { Button } from "@/components/ui/button";
import { Webhook, Bug } from "lucide-react";
const Settings = () => {
  const {
    user,
    logout,
    hasRole
  } = useAuth();
  const isAdmin = hasRole('admin');
  const canManageUsers = hasRole('admin') || hasRole('integrations_manager');
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("profile");

  // Check for tab parameter in URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");
    if (tab && ["profile", "company", "users", "security", "subscription"].includes(tab)) {
      setActiveTab(tab);
    }
  }, [location]);
  return <div className="space-y-8">
      <header>
        <h1 className="text-2xl font-bold">Configurações</h1>
        <p className="text-gray-500">Gerencie as configurações da sua conta</p>
      </header>

      

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full max-w-md grid-cols-5">
          <TabsTrigger value="profile">Perfil</TabsTrigger>
          <TabsTrigger value="company">Empresa</TabsTrigger>
          <TabsTrigger value="subscription">Assinatura</TabsTrigger>
          <TabsTrigger value="users">Usuários</TabsTrigger>
          <TabsTrigger value="security">Segurança</TabsTrigger>
        </TabsList>
        
        <TabsContent value="profile" className="mt-6">
          <ProfileTab user={user} />
        </TabsContent>
        
        <TabsContent value="company" className="mt-6">
          <CompanyTab />
        </TabsContent>
        
        <TabsContent value="subscription" className="mt-6">
          <PaymentSection />
          <PaymentHistorySection />
        </TabsContent>
        
        <TabsContent value="users" className="mt-6">
          <UsersTab />
          {canManageUsers && <Card className="mt-6 border-green-200 shadow-sm">
              <CardHeader className="bg-green-50">
                <CardTitle>Gerenciamento de Funções</CardTitle>
                <CardDescription>
                  Gerencie as funções dos usuários no sistema
                </CardDescription>
              </CardHeader>
              <CardContent>
                <RoleManagement />
              </CardContent>
            </Card>}
          <DangerZone logout={logout} />
        </TabsContent>

        <TabsContent value="security" className="mt-6">
          <SecurityLogsTab />
        </TabsContent>
      </Tabs>
    </div>;
};
export default Settings;